import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "One platform · multiple solutions — from cabling to CCTV",
  "Certified testing with Fluke & OTDR for guaranteed performance",
  "Seamless integration of security, networking & power",
  "Maharashtra-based team · pan-India service capability",
];

const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid-faint" />
      <div className="orb bg-[#FF6B00]/10 w-[420px] h-[420px] -bottom-40 right-10" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-white/10">
            <img
              src="https://images.pexels.com/photos/17489151/pexels-photo-17489151.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700"
              alt="Server infrastructure"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060B14] via-transparent to-transparent" />
          </div>
          <div className="absolute -right-5 -bottom-5 bg-[#0B1320] border border-white/10 p-5 max-w-[200px]">
            <div className="font-display text-3xl font-bold text-[#FF6B00]">07+</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A0B2C6] mt-1">
              years of <br />network engineering
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7"
        >
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF6B00] mb-4">
            ◆ About HRN Networks
          </div>
          <h2 data-testid="about-title" className="font-display text-4xl sm:text-5xl font-bold leading-[1.05] tracking-tighter">
            Your trust, our technology — <br />
            <span className="text-[#A0B2C6]">connected for a smarter tomorrow.</span>
          </h2>
          <p className="mt-6 text-lg text-[#A0B2C6] leading-relaxed max-w-xl">
            HRN Networks is a networking solutions and application engineering partner
            for enterprises, campuses, and growing businesses. We design, install,
            certify and maintain the systems that keep your operations connected,
            secure, and measurable.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {POINTS.map((p, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-[#F0F4F8]">
                <CheckCircle2 size={18} className="text-[#FF6B00] mt-0.5 shrink-0" strokeWidth={1.8} />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
